export default __webpack_public_path__ + "static/zoom-8159493183dfbae01d838d3ec9125e95.png";